import { Interpolation } from "@emotion/core";
import { Fonts } from "../../../../design-tokens/fonts";
import { grid } from "../../../../design-tokens/grid";
import { Device, DarkTheme } from "../../../../design-tokens/media-queries";
import { Border } from "../../../../design-tokens/borders";
import CrushTheCurveDM from "./assets/crush-the-curve-dark-mode.svg";
import CrushTheCurveLM from "./assets/crush-the-curve-light-mode.svg";

const heading: Interpolation = {
  fontSize: "24px",
  lineHeight: "30px",
  fontWeight: Fonts.Weight.Bold,
  marginBottom: grid(2),

  [Device.DesktopTablet]: {
    marginBottom: grid(2.5),
  },
};

const content: Interpolation = {
  fontSize: "18px",
  marginBottom: grid(4),
};

const graphContainer: Interpolation = {
  [Device.Mobile]: {
    overflow: "auto",
    marginLeft: grid(-2),
    marginRight: grid(-2),
  },
};

const graphs: Interpolation = {
  [Device.Mobile]: {
    width: grid(75.5),
    paddingLeft: grid(2),
    paddingRight: grid(2),
  },
};

const crushCurve: Interpolation = {
  height: grid(31),
  background: `url(${CrushTheCurveLM}) center no-repeat`,
  marginBottom: grid(1),

  [DarkTheme]: {
    background: `url(${CrushTheCurveDM}) center no-repeat`,
  },
};

const ecvLogo: Interpolation = {
  display: "inline-block",

  "> img": {
    width: grid(21.5),
    borderRadius: Border.RadiusSm,
    overflow: "hidden",
  },

  [Device.Mobile]: {
    marginTop: grid(3),
  },
};

const styles = {
  heading,
  content,
  graphContainer,
  graphs,
  crushCurve,
  ecvLogo,
};

export default styles;
